import { render, staticRenderFns } from "./pipe-notifications.vue?vue&type=template&id=6b5b462a&scoped=true"
import script from "./pipe-notifications.vue?vue&type=script&lang=js"
export * from "./pipe-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b462a",
  null
  
)

export default component.exports